export function formatPrice(price) {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'

    // These options are needed to round to whole numbers if that's what you want.
    // minimumFractionDigits: 0, // (this suffices for whole numbers,
    // but will print 2500.10 as $2,500.1)
    // maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  })

  return formatter.format(Number(price / 100))
}

export function getTrialEndDate(freeTrialDays) {
  // Create a new date object for the current date
  const currentDate = new Date()

  // Add the free trial days to the current date
  currentDate.setDate(currentDate.getDate() + +freeTrialDays)

  // Return the charge date
  // Format the date
  const options = { year: 'numeric', month: 'long', day: 'numeric' }
  const formattedDate = currentDate.toLocaleDateString(undefined, options)

  // Return the formatted charge date
  return formattedDate
}

export function workoutInstructionsPath(route, week, day, globalProgId, clientId) {
  const weekPath = week.replace(/\s+/g, '-').toLowerCase()
  const dayPath = day.replace(/\s+/g, '-').toLowerCase()
  if (route.path === '/fitness-program-manager') {
    return `global-fitness-programs/${globalProgId}/workoutInstructions/notes/${weekPath}/${dayPath}`
  }

  return `fitness-program-notes/${clientId}/${weekPath}/${dayPath}`
}

export default {
  formatPrice,
  getTrialEndDate,
  workoutInstructionsPath
}
